import { motion } from "framer-motion";
import { Building2, User } from "lucide-react";

const ExpertTypeSelection = ({ onSelect }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="mb-6">
        <h1 className="text-white text-[2rem]">1. Je suis:</h1>
        <p className="text-gray-300 text-[1.2rem] ">
          Veuillez sélectionner une option pour continuer.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-8">
        <div
          onClick={() => onSelect("Personne physique")}
          className="bg-blue-800/30 rounded-2xl p-8 text-white cursor-pointer hover:bg-blue-700/40 transition-colors"
        >
          <User className="w-12 h-12 mb-4" />
          <h3 className="lg:text-2xl text-xl font-bold mb-2">
            Expert Personne Physique
          </h3>
          <p className="text-blue-200">Pour les professionnels individuels</p>
        </div>
        <div
          onClick={() => onSelect("Personne moral")}
          className="bg-blue-800/30 rounded-2xl p-8 text-white cursor-pointer hover:bg-blue-700/40 transition-colors"
        >
          <Building2 className="w-12 h-12 mb-4" />
          <h3 className="lg:text-2xl text-xl font-bold mb-2">
            Expert Personne Morale
          </h3>
          <p className="text-blue-200">Pour les organisations et entreprises</p>
        </div>
      </div>
    </motion.div>
  );
};

export default ExpertTypeSelection;
